/*
 * @Author: Z-MZ 57248255+Z-MZ@users.noreply.github.com
 * @Date: 2022-09-21 15:57:15
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @LastEditTime: 2022-11-15 09:54:16
 * @FilePath: \frontend-user\src\utils\openreplay.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import OpenReplay from '@openreplay/tracker'
import trackerVuex from '@openreplay/tracker-vuex'
import { analyticsAllowedAt } from '@/utils/menu/previewMenu'

let tracker = null
let vuexPlugin = null

/**
 * Get user information
 * @returns {Object} User information
 */
/**
 * 获取用户信息
 * @returns {Object} 用户信息
 */
function getUserInfo() {
  if (localStorage.userId) {
    const vuex = JSON.parse(localStorage.vuex)
    const userInfo = vuex?.contactDetails?.user ?? {}
    return {
      id: localStorage?.userId ?? userInfo?.id ?? '',
      email: userInfo?.email ?? '',
      name: userInfo?.name ?? '',
      phone: userInfo?.phone ?? '',
    }
  }
  return {}
}

// If the tracker already exists, the deployment will not be executed
// 若已存在 tracker，则不再执行部署
// 多版本菜单 B6（U-B6-3，owner D93）：菜单预览页（地址里有 previewMenu 键）不录屏 —— 不建 tracker、不 start，
// vuexPlugin 留 null（store/index.js 判空）。启动时按地址判一次（见 utils/menu/previewMenu.js）
if (!tracker && (process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'test') && analyticsAllowedAt(window.location.search)) {
  const projectKey = process.env.VUE_APP_ENV === 'production' ? 'DGJInggPsqmsWOreY1rE' : 'JPaC2x8VUQ5ASX90CirK'
  tracker = new OpenReplay({
    projectKey: projectKey,
    defaultInputMode: 0,
    obscureInputEmails: false,
    ingestPoint: 'https://openreplay.mondoconnex.com/ingest'
  })
  // Get user information
  // 获取用户信息
  const userInfo = getUserInfo()
  const userId = userInfo?.email ?? ''
  // 添加vuex 中的插件配置  - do not use vuex tracker due to performance issue
  vuexPlugin = tracker.use(trackerVuex()) // check list of available options below
  tracker.start(
    {
      userID: userId,
      metadata: {
        id: userInfo.id,
        name: userInfo.name,
        phone: userInfo.phone
      }
    }
  ).then(res => {
    localStorage.setItem('openreplaySessionID', res?.sessionID ?? '')
  }).catch(error => {
    console.log(error)
    localStorage.setItem('openreplaySessionID', '')
  })
  localStorage.setItem('openreplayUserId', userId)
}

/**
 * Openreplay setting userID
 * @param {String} userID The userID to set
 */
/**
 * openreplay 设置 userID
 * @param {String} userID 要设置的 userID
 */
function openreplaySetUserID(userID) {
  // If there is no tracker, no operation will be performed
  // 若没有 tracker，则不进行操作（多版本菜单 B6 U-B6-3：连 localStorage 也不写 —— 预览页 / 不录屏的环境不留这条记录）
  if (!tracker) return
  tracker.setUserID(userID)
  localStorage.setItem('openreplayUserId', userID)
}

/**
 * Openreplay setting Metadata
 * @param {String} key Target key to set
 * @param {*} val Value to be set to
 */
/**
 * openreplay 设置 Metadata
 * @param {String} key 要设置的目标 key
 * @param {*} val 要设置成的值
 */
function openreplaySetMetadata(key, val) {
  // If there is no tracker, no operation will be performed
  // 若没有 tracker，则不进行操作
  if (tracker) tracker.setMetadata(key, val)
}

/**
 * Openreplay submission error
 * @param {*} err error message
 */
/**
 * openreplay 提交错误
 * @param {*} err 错误信息
 */
function openreplayHandlerError(err) {
  // If there is no tracker, no operation will be performed
  // 若没有 tracker，则不进行操作
  if (tracker) tracker.handleError(err)
}

export default {
  install(Vue) {
    Vue.prototype.$openreplayTracker = tracker
  }
}

export {
  openreplaySetUserID,
  openreplaySetMetadata,
  openreplayHandlerError,
  vuexPlugin,
  tracker
}
